<template>
    <div class="wrapper padding-sm bg-white">
        <div class=" flex justify-between align-center margin-bottom-sm">
            <div class="page-title">短信群发 <span>用短信通知会员 高效精准阅读率更高</span></div>
            <el-button class="blue-btn" round @click="$router.go(-1)">返回</el-button>
        </div>
        <div class=" flex justify-between align-center margin-bottom-sm">
            <div class="page-title-two">系统会员/分支机构</div>
            <el-button
                class="blue-btn"
                round
                type="primary"
                @click="chioseDialog = true"
            >
                {{
                    members.length === 0 && membersFh.length === 0 ? "会员/分支机构选择" : "已选择" +
                        (members.length + membersFh.length) + "家会员/分支机构"
                }}
            </el-button>
        </div>
        <div v-if="membersList.length>0 || membersListFh.length>0" class="member-list-box">
            <el-row :gutter="10">
                <el-col v-for="item in membersList" :key="item.user_id" :span="8">
                    <div class="member-item">
                        <div class="ovHide">机构：{{ item.company }}</div>
                        <div>电话：{{ item.phone }}</div>
                    </div>
                </el-col>
                <el-col v-for="item in membersListFh" :key="item.id" :span="8">
                    <div class="member-item">
                        <div class="ovHide">机构：{{ item.name }}</div>
                        <div>电话：{{ item.user_name }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class=" flex justify-between align-center margin-bottom-sm">
            <div class="page-title-two">外部联系人</div>
            <div class="flex align-center">
                <el-button
                    class="blue-btn"
                    round
                    style="width: 143px"
                    type="primary"
                    @click="otherDialog = true"
                >
                    联系人添加
                </el-button>
                <el-upload
                    :action="`${baseURL}Admin/Sendsms/parsingExcelPhone`"
                    :data="fileData"
                    :name="'file'"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    class="margin-left-xs">
                    <el-button
                        class="blue-btn"
                        round
                        style="width: 143px"
                        type="primary">
                        联系人导入
                    </el-button>
                </el-upload>

                <a class="margin-left-xs" target="_blank" :href="`${IMAGE_PATH}upload/excelphone/phone_demo.xls`">
                    <el-button
                        class="blue-btn"
                        round
                        style="width: 143px"
                        type="primary">
                        下载模版
                    </el-button>
                </a>
            </div>
        </div>
        <div v-if="othermembersList.length>0" class="member-list-box">
            <el-row :gutter="10">
                <el-col v-for="(item,index) in othermembersList" :key="index" :span="8">
                    <div class="member-item">
                        <div class="ovHide">机构：{{ item.company }}</div>
                        <div class="flex align-center justify-between">电话：{{ item.phone }}
                            <el-link type="danger" @click="otherDel(index)"><i class="el-icon-delete"></i></el-link>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="sms-container flex flex-direction">
            <div class=" flex justify-between align-center">
                <div class="page-title-two ">短信内容 <span>申请短信模版、短信充值请联系客服</span> <i>400-999-6541</i></div>
                <div class="page-tip">目前{{ inputCount }}个字符，预计耗费<span>{{ Math.ceil(inputCount / 140) }}</span>条短信,目前剩余<span>{{smsNumber}}</span>条</div>
            </div>
            <el-radio-group v-model="demo_index" class="margin-tb-sm" @change="demoChange">
                <el-radio v-for="(item,index) in demos" :key="index" :label="index" border>模版{{ index + 1 }}</el-radio>
            </el-radio-group>
            <el-input
                v-if="demo_index === 1"
                v-model="message"
                :rows="5"
                class="margin-bottom-sm"
                placeholder="请输入您要发送的内容"
                resize="none"
                type="textarea"
            ></el-input>
            <div class="sms-perview margin-bottom">
                {{ demo_message }}
            </div>

            <el-button class="self-end" type="primary" @click="sendMessage">发送短信</el-button>
        </div>
        <chiose-dialog
            :chioseDialog="chioseDialog"
            @cancelChiose="cancelChiose"
            @saveChiose="saveChiose"
        />
        <add-other-member-dialog
            :apply-dialog-visible="otherDialog"
            @saveOther="saveOther"
            @watchState="watchState"
        />
    </div>
</template>

<script>
import {getSmsDemoList, sendMessage,getSMSShengYuNumber} from "@/api/organiz";
import ChioseDialog from "@/components/ChioseDialog";
import AddOtherMemberDialog from "@/components/AddOtherMemberDialog";
import {baseURL, IMAGE_PATH} from "@/config";

export default {
    name: "send",
    data() {
        return {
            baseURL:baseURL,
            IMAGE_PATH:IMAGE_PATH,
            message: '',
            demos: [],
            demo_index: 0,
            demo_message: '',
            demo: '',
            inputCount: 0,
            chioseDialog: false,
            members: [],
            membersList: [],
            membersFh: [],
            membersListFh: [],
            otherDialog: false,
            othermembersList: [],
            smsNumber:0,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                mid: this.$store.state.user.mid
            }
        }
    },
    created() {
        this.$emit('setIndex', [1, 1], '短信群发')
        this.getSmsDemoList()
        this.init()
    },
    components: {
        ChioseDialog,
        AddOtherMemberDialog
    },
    methods: {
        async init(){
            let _data = await  getSMSShengYuNumber()
            this.smsNumber = _data.data
        },
        async sendMessage() {
            if (this.membersList.length === 0 && this.membersListFh.length === 0 && this.othermembersList.length === 0) return this.$message.error('请选择系统会员/分支机构或填写外部联系人')

            let _arr = []
            this.membersList.map(item => {
                _arr.push({name: item.company, phone: item.phone})
            })
            this.membersListFh.map(item => {
                _arr.push({name: item.name, phone: item.user_name})
            })
            this.othermembersList.map(item => {
                _arr.push({name: item.company, phone: item.phone})
            })
            let count = Math.ceil(this.inputCount / 140) * _arr.length
            if (this.smsNumber < count) return  this.$message.error('剩余条数不足')
            let _state = await sendMessage(
                this.user.morgname + ',' + this.message,
                this.demo.template_id,
                JSON.stringify(_arr),count
            )
            this.$message.success(_state.msg)
            this.$router.go(-1)
        },
        //  删除外部联系人
        otherDel(index) {
            this.$confirm('此操作将删除该联系人, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                center: true
            }).then(() => {
                this.othermembersList.splice(index, 1)
            })
        },
        //  保存外部联系人
        saveOther(val) {
            this.othermembersList.push(JSON.parse(JSON.stringify(val)))
            this.watchState()
        },
        //  关闭外部联系人
        watchState() {
            this.otherDialog = false
        },
        //  标签选择保存发送人员
        saveChiose(val) {
            this.chioseType = val[0]
            this.members = val[1]
            this.membersList = val[2]
            this.membersFh = val[3]
            this.membersListFh = val[4]
            this.cancelChiose()
        },
        //  关闭弹框
        cancelChiose() {
            this.chioseDialog = false
        },
        //  模版选择
        demoChange(e) {
            this.demo = this.demos[e]
            this.demo_message = this.demo.demo.replaceAll('{1}', this.user.morgname)
            this.demo_message = this.demo_message.replaceAll('{2}', '内容')
            this.inputCount = this.getByteLen(this.demo_message)
            this.message = ''
        },
        getByteLen(val) {
            let len = 0;
            for (let i = 0; i < val.length; i++) {
                let a = val.charAt(i);
                if (a.match(/[^\\x00-\\xff]/ig) != null) {
                    len += 2;
                } else {
                    len += 1;
                }
            }
            return len;
        },
        //  获取模版
        async getSmsDemoList() {
            let _data = await getSmsDemoList()
            this.demos = _data.data
            this.demo = _data.data[this.demo_index]
            this.demo_message = this.demo.demo.replaceAll('{1}', this.user.morgname)
            this.demo_message = this.demo_message.replaceAll('{2}', '内容')
            this.inputCount = this.getByteLen(this.demo_message)
        },
        handleAvatarSuccess(res) {
            if (res.status === 200) {
                res.data.map(item=>{
                    item.company = item.name
                })
                this.othermembersList = [...this.othermembersList,...res.data]
            } else {
                this.$message.error(res.msg)
            }
        },
    },
    filters: {},
    watch: {
        message() {
            this.demo_message = this.demo.demo.replaceAll('{1}', this.user.morgname)
            this.demo_message = this.demo_message.replaceAll('{2}', this.message ? this.message : ' ')
            this.inputCount = this.getByteLen(this.demo_message)
        }
    },
}
</script>

<style lang="scss" scoped>
.wrapper {
    .page-title {
        span {
            font-size: 16px;
            line-height: 45px;
            color: #999999;
            font-weight: normal;
        }
    }

    .page-title-two {
        width: 60%;

        span {
            font-size: 16px;
            line-height: 45px;
            color: #999999;
            font-weight: normal;
        }

        i {
            display: inline-block;
            width: 140px;
            height: 18px;
            text-align: center;
            line-height: 18px;
            font-size: 14px;
            background-image: linear-gradient(37deg,
                #ffb400 0%,
                #fc7802 100%),
            linear-gradient(
                    #0a2240,
                    #0a2240);
            background-blend-mode: normal,
            normal;
            border-radius: 9px;
            color: #fff;
        }
    }

    .page-tip {
        span {
            color: #ffb400;
        }
    }

    .member-list-box {
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;

        .member-item {
            background: rgba(#fff, .4);
            border: 1px dashed #ffb400;
            border-radius: 4px;
            padding: 5px 10px;
            margin-bottom: 10px;
            font-size: 14px;
            line-height: 20px;
            color: #0a2240;
        }
    }

    .self-end {
        display: block;
        width: 200px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        padding: 0;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#0a2240, #0a2240);
        background-blend-mode: normal, normal;
        border-radius: 20px;
        font-size: 16px;
        color: #fff;
    }
}
</style>